import { render, staticRenderFns } from "./ListItemLabel.vue?vue&type=template&id=83039102&"
import script from "./ListItemLabel.vue?vue&type=script&lang=ts&"
export * from "./ListItemLabel.vue?vue&type=script&lang=ts&"
import style0 from "./ListItemLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports